import {Column} from 'react-table'
import {CDRAi} from './CDRAi'
import {CDRIcons} from './CDRIcons'
import {CDRRecord} from './CDRRecord'
import {CDRClient} from './CDRClient'
import {CDRStatus} from './CDRStatus'
import {CDROperator} from './CDROperator'
import {DataCDR} from '../../core/_models'
import {CDRDidNumber} from './CDRDidNumber'
import {CDRCallStart} from './CDRCallStart'
import {CDRDialDuration} from './CDRDialDuration'
import {CDRCustomHeader} from './CDRCustomHeader'
import {CDRTalkDuration} from './CDRTalkDuration'

const CDRColumns: Column<DataCDR>[] = [
  {
    Header: (props) => <CDRCustomHeader tableProps={props} className='min-w-15px' />,
    accessor: 'id',
    Cell: ({...props}) => <CDRIcons data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Клиент' className='min-w-125px text-gray-700' />,
    accessor: 'from_',
    Cell: ({...props}) => (
      <CDRClient
        data={
          props.data[props.row.index].direction === 'INBOUND'
            ? props.data[props.row.index].from_
            : props.data[props.row.index].to_
        }
        clientInfo={props.data[props.row.index].client_info}
      />
    ),
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Сотрудник' className='min-w-200px text-gray-700' />,
    id: 'to_',
    Cell: ({...props}) => (
      <CDROperator
        data={
          props.data[props.row.index].direction === 'INBOUND'
            ? props.data[props.row.index].to_
            : props.data[props.row.index].from_
        }
      />
    ),
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Линия' className='min-w-125px text-gray-700' />,
    accessor: 'did_number',
    Cell: ({...props}) => <CDRDidNumber data={props.data[props.row.index].did_number} />,
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Дата вызова' className='min-w-75px text-gray-700' />,
    accessor: 'call_start',
    Cell: ({...props}) => <CDRCallStart data={props.data[props.row.index].call_start} />,
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Статус' className='min-w-100px text-gray-700' />,
    accessor: 'status',
    Cell: ({...props}) => <CDRStatus data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Ожидание' className='min-w-100px text-gray-700' />,
    accessor: 'dial_duration',
    Cell: ({row}) => <CDRDialDuration data={row.original.dial_duration - row.original.talk_duration} />,
  },
  {
    Header: (props) => (
      <CDRCustomHeader tableProps={props} title='Длительность' className='min-w-125px text-gray-700' />
    ),
    accessor: 'talk_duration',
    Cell: ({...props}) => <CDRTalkDuration data={props.data[props.row.index].talk_duration} />,
  },
  {
    Header: (props) => <CDRCustomHeader tableProps={props} title='Запись' className='text-gray-700' />,
    accessor: 'record_url',
    Cell: ({...props}) => <CDRRecord data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CDRCustomHeader tableProps={props} title='AI' className='min-w-25px text-gray-700 text-center' />
    ),
    accessor: 'llm_analysis',
    Cell: ({...props}) => <CDRAi data={props.data[props.row.index]} />,
  },
]

export {CDRColumns}
